<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'Account'
}
</script>

<style scoped>

</style>
